module.exports = __webpack_public_path__ + "media/img/home/directions/list-7-fc4078c9a97793a2006a8cec6bdba390.svg";